import defaultsDeep from 'lodash/defaultsDeep';

const initialState = {};

export default function settingsReducer(state = initialState, action = {}) {
  switch (action.type) {
    case 'GET_EMAIL_SETTINGS_SUCCESS':
      return defaultsDeep(state, {
        refundEmail: {
          branchIds: action.payload.restaurant_ids,
        },
      });
    default:
      return state;
  }
}
